import api from "../../api.js";

export async function fetchStockTransfers() {
  const res = await api.get("/api/stock-transfer");
  return res.data?.data || [];
}

export async function addStockTransferToInventory(requestId) {
  await api.post(`/api/stock-transfer/${requestId}/add-to-inventory`);
}

